// Centralized configuration for admin functionality

// DEPRECATED: This hardcoded list is kept for backward compatibility only.
// New code should use the useIsAdmin hook or check the admin_users database table.
// The database table is the source of truth for admin status.
// 
// To add a new admin user, use the UI at /admin/users or insert into admin_users table.
export const ADMIN_USER_IDS = [
  "359a23ec-f3a7-4761-aa09-d660bb92016d", // Main admin ID from AdminImpersonation.tsx
  "c97203fd-55ed-4f40-8437-447013c6222d", // Additional admin user
  "fc45617b-2ffb-4b9b-8afa-c8beb8429196",
  "c8e572cf-15b7-44d6-b9c2-9d7d0f0d0fb4"
];

/**
 * @deprecated Use the useIsAdmin hook instead, which checks the admin_users database table.
 * This function is kept for backward compatibility but should not be used in new code.
 * 
 * Function to check if a user is an admin (checks hardcoded list only).
 * For database-backed admin checks, use useIsAdmin hook.
 */
export const isUserAdmin = (userId?: string | null): boolean => {
  if (!userId) return false;
  return ADMIN_USER_IDS.includes(userId);
};

// Admin pages configuration
export const ADMIN_PAGES = [
  {
    key: "admin-pricing",
    title: "Invoice Settings",
    path: "/admin/pricing",
    description: "Manage invoice creation and billing processes",
  },
  {
    key: "admin-tariffs",
    title: "Tariffs Administration",
    path: "/admin/tariffs",
    description: "Manage tariffs for different routes and periods",
  },
  {
    key: "admin-tasks",
    title: "Task Management",
    path: "/admin/tasks",
    description: "Create and manage tasks assigned to team members",
  },
  {
    key: "admin-users",
    title: "User Management",
    path: "/admin/users",
    description: "Manage user accounts, roles and permissions",
  },
  {
    key: "admin-ports",
    title: "Ports Administration",
    path: "/admin/ports",
    description: "Manage origin and destination ports for shipments",
  },
  {
    key: "admin-bookings",
    title: "Bookings",
    path: "/admin/bookings",
    description: "Manage and track customer bookings",
  },
  {
    key: "admin-reports",
    title: "Reports",
    path: "/admin/reports",
    description: "View system reports and analytics",
  },
  {
    key: "admin-containers",
    title: "Containers Administration",
    path: "/admin/containers",
    description: "Manage shipping containers and consolidations",
  },
  {
    key: "admin-invoices",
    title: "Invoices",
    path: "/admin/invoices",
    description: "Manage customer invoices and payments",
  },
  {
    key: "admin-email-notifications",
    title: "Email Notifications",
    path: "/admin/email-notifications",
    description: "View and manage email notifications sent to users",
  },
  {
    key: "admin-announcement-banner",
    title: "Announcement banner",
    path: "/admin/announcement-banner",
    description: "Manage announcement banners (title, subject, style, set live)",
  },
  {
    key: "admin-blog",
    title: "Blog",
    path: "/admin/blog",
    description: "Create, edit, and publish blog posts (shown on dashboard)",
  },
  {
    key: "admin-wms-manual-orders",
    title: "WMS manual orders",
    path: "/admin/wms-manual-orders",
    description: "Quote and manage manual WMS orders (Picqer or ChannelDock, large shipments)",
  },
  {
    key: "admin-picqer-analyse",
    title: "Picqer analyse",
    path: "/admin/picqer-analyse",
    description: "Warehouse location occupation analysis from Picqer stock history",
  },
  {
    key: "admin-roadmap",
    title: "Roadmap",
    path: "/admin/roadmap",
    description: "Internal backlog, working notes, sub-todos, and chat-friendly copy",
  },
  {
    key: "admin-automations",
    title: "Automations",
    path: "/admin/automations",
    description: "What updates booking statuses and what runs when a status is reached",
  },
  {
    key: "admin-bot",
    title: "Bot",
    path: "/admin/bot",
    description: "Look up companies and users by email or phone for the Gmail/WhatsApp bot",
  },
  // Add new admin pages here as they are created
];

// Helper to check if a given path is an admin page
export const isAdminPage = (path: string): boolean => {
  return ADMIN_PAGES.some((page) => path.startsWith(page.path));
}; 